import videoImg from '../img/rank-video-default-img.jpg'

export default () => ({
    oneNewsList: [
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '20',
            title: '区块链技术的监管重点在哪儿？20'
        },
        {
            id: '21',
            title: '区块链技术的监管重点在哪儿？21'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '40',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '41',
            title: '区块链技术的监管重点在哪儿41？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '1',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '60',
            title: '区块链技术的监管重点在哪儿？'
        },
        {
            id: '61',
            title: '区块链技术的监管重点在哪儿？'
        }
    ],
    twoVideoList: [
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        },
        {
            img: videoImg,
            title: '视频标题最多显示两行更多省略号'
        }
    ],
    // 0:全部;1:新闻(标题、摘要和内容搜索); 2:快讯(标题和内容); 3:专栏作者; 4:专题(名称); 5:视频(名称) String
    searchTabType: [
        { type: 0, label: '综合' },
        { type: 99, label: '精选' },
        { type: 1, label: '新闻' },
        { type: 2, label: '快讯' },
        { type: 3, label: '作者' }
    ],
    // 搜索标签枚举
    searchTabTypeEnum: {
        ALL: 0, // 综合
        EXCELLENTNEWS: 99, // 精选
        NEWS: 1, // 新闻
        FLASH: 2, // 快讯
        AUTHOR: 3 // 作者
    },
    searchMTabType: [
        { type: 1, label: '新闻' },
        { type: 2, label: '快讯' },
        { type: 3, label: '行情' }
    ],
    jsonObj: {
        'pcBackImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601269124765.jpg',
        'mBackImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601268599079.jpg',
        'blockChainGeneralKnowledge': {
            'title': '区块链通识课',
            'pcImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601266556014.jpg',
            'mImgUrl': '',
            'introduce': '在这里，小白也能读懂区块链',
            'newsList': [
                {
                    'title': '第1期：比特币和腾讯的Q币一样吗？',
                    'url': 'https://news.huoxing24.com/20191026210220968971.html'
                },
                {
                    'title': '第2期：你听说过价值3亿元的披萨吗？',
                    'url': 'https://news.huoxing24.com/20191026210315241003.html'
                },
                {
                    'title': '第3期：为什么委内瑞拉民众争着购买比特币？',
                    'url': 'https://news.huoxing24.com/20191026210441484741.html'
                },
                {
                    'title': '第4期：藏身10多年无人知晓，比特币创始人到底是谁？',
                    'url': 'https://news.huoxing24.com/20191026210536805844.html'
                },
                {
                    'title': '第5期：做一名比特币矿工，是怎样的体验？',
                    'url': 'https://news.huoxing24.com/20191026211203774579.html'
                },
                {
                    'title': '第6期：为什么股神巴菲特说比特币是金融行业的“老鼠药”？',
                    'url': 'https://news.huoxing24.com/20191028212518489895.html'
                },
                {
                    'title': '第7期：被宣布死刑300次之后，比特币为什么还没死？',
                    'url': 'https://news.huoxing24.com/20191030183837809248.html'
                },
                {
                    'title': '第8期：比特币就是区块链吗？',
                    'url': 'https://news.huoxing24.com/20191031190132927830.html'
                },
                {
                    'title': '第9期：为什么说区块链是一部“信任的机器”？',
                    'url': 'https://news.huoxing24.com/20191101175716215833.html'
                },
                {
                    'title': '第10期：人手一册的区块链账本是什么东西？？',
                    'url': 'https://news.huoxing24.com/20191102212310990217.html'
                },
                {
                    'title': '第11期：每天烧掉上千万的算力大战到底在争什么？',
                    'url': 'https://news.huoxing24.com/20191103091005904789.html'
                },
                {
                    'title': '第12期：从《九阴真经》到区块链的加密算法 ',
                    'url': 'https://news.huoxing24.com/20191104190531460728.html'
                },
                {
                    'title': '第13期：大话区块链的共识机制（上）',
                    'url': 'https://news.huoxing24.com/20191105164741559429.html'
                },
                {
                    'title': '第14期：大话区块链的共识机制（下）',
                    'url': 'https://news.huoxing24.com/20191105165055300663.html'
                },
                {
                    'title': '第15期：公链、私链、联盟链谁才是真正的区块链?',
                    'url': 'https://news.huoxing24.com/20191105170117230001.html'
                }
            ]
        },
        'blockChainVideo': {
            'title': '区块链入门到精通',
            'pcImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601266825467.jpg',
            'mImgUrl': '',
            'introduce': '晋级，提升你对区块链的专业认知',
            'newsList': [
                {
                    'title': '第1期：从三千年前的故事读懂区块链是什么',
                    'url': 'https://news.huoxing24.com/20191026195108030690.html'
                },
                {
                    'title': '第2期：区块链技术的来源',
                    'url': 'https://news.huoxing24.com/20191026201037809177.html'
                },
                {
                    'title': '第3期：比特币的加密与交易',
                    'url': 'https://news.huoxing24.com/20191026201610986592.html'
                },
                {
                    'title': '第4期：区块链的存储结构',
                    'url': 'https://news.huoxing24.com/20191026195201717406.html'
                },
                {
                    'title': '第5期： 区块链的三大特性',
                    'url': 'https://news.huoxing24.com/20191026193935164895.html'
                },
                {
                    'title': '第6期：矿工、矿机、矿场和矿池',
                    'url': 'https://news.huoxing24.com/20191026195723203287.html'
                },
                {
                    'title': '第7期：从玄武门之变到分叉和算力攻击',
                    'url': 'https://news.huoxing24.com/20191030184605621710.html'
                },
                {
                    'title': '第8期：拜占庭将军问题',
                    'url': 'https://news.huoxing24.com/20191031190823315601.html'
                },
                {
                    'title': '第9期：共识漫谈之POW机制',
                    'url': 'https://news.huoxing24.com/20191101180222012458.html'
                },
                {
                    'title': '第10期：共识漫谈之常见共识机制',
                    'url': 'https://news.huoxing24.com/20191102212924985450.html'
                },
                {
                    'title': '第11期：智能合约',
                    'url': 'https://news.huoxing24.com/20191104191546704431.html'
                },
                {
                    'title': '第12期：以太坊及其应用场景',
                    'url': 'https://news.huoxing24.com/20191105170554879422.html'
                },
                {
                    'title': '第13期：EOS及其社区治理',
                    'url': 'https://news.huoxing24.com/20191105181044195029.html'
                }
            ]
        },
        'blockChainOpenClass': {
            'title': '区块链公开课',
            'pcImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601267349759.jpg',
            'mImgUrl': '',
            'introduce': '行情最前线，区块链从业者专题知识分享',
            'newsList': [
                {
                    'title': '第1期：未来资本戴跃：给区块链公司域名方面的一些建议',
                    'url': 'https://news.huoxing24.com/2018031301444234345.html'
                },
                {
                    'title': '第2期：买牛、老白、Alex：被誉为“区块链3.0”的EOS真的有那么牛吗？',
                    'url': 'https://news.huoxing24.com/2018031318183323949.html'
                },
                {
                    'title': '第4期：秀币CEO胡震生：区块链的三大基石',
                    'url': 'https://news.huoxing24.com/2018031418431833990.html'
                },
                {
                    'title': '第5期：北大经济学博士刘昌用：区块链失去了“去中心化”，称不上是革命',
                    'url': 'https://news.huoxing24.com/2018031620243519177.html'
                },
                {
                    'title': '第6期：NEO 全球资本合伙人朱威宇：今年Token市场以机构为主导，更注重项目实质',
                    'url': 'https://news.huoxing24.com/2018031719525673597.html'
                },
                {
                    'title': '第7期：CWV王小彬：游戏，是除金融外区块链最快落地的行业',
                    'url': 'https://news.huoxing24.com/2018031920044988612.html'
                },
                {
                    'title': '第8期：数字货币爱好者LEO： token不完全等同于证券',
                    'url': 'https://news.huoxing24.com/2018032018155988879.html'
                },
                {
                    'title': '第9期：YOYOW Alex：区块链在内容领域的应用',
                    'url': 'https://news.huoxing24.com/2018032216044384592.html'
                },
                {
                    'title': '第10期：LITEX创始人王硕斌：各条公链在建岛，我们在建高架桥',
                    'url': 'https://news.huoxing24.com/2018032222065423896.html'
                },
                {
                    'title': '第11期：Bodhi创始人林吓洪：为什么我选择在区块链上创建去中心化预测市场',
                    'url': 'https://news.huoxing24.com/2018032318164431636.html'
                },
                {
                    'title': '第12期：UOC开源社区联合发起人贾可：网络游戏，区块链精神的战略试验田',
                    'url': 'https://news.huoxing24.com/2018032420474672992.html'
                },
                {
                    'title': '第13期：QunQun创始人欧胜：Token激励将革新社区平台？',
                    'url': 'https://news.huoxing24.com/2018032600482133980.html'
                },
                {
                    'title': '第14期：Quoinex CFO Konno Katsuya：日本虚拟货币交易所现状分析',
                    'url': 'https://news.huoxing24.com/2018032613503250888.html'
                },
                {
                    'title': '第15期：Coinfo刘勇：Coinfo，打造数字货币帝国的华尔街',
                    'url': 'https://news.huoxing24.com/2018032621021086584.html'
                },
                {
                    'title': '第16期：音悦Tai CEO张斗：从韩国三大交易所看2018年区块链应用落地',
                    'url': 'https://news.huoxing24.com/2018032717134903972.html'
                },
                {
                    'title': '第17期：韩国Translink合伙人Hur博士：2018年逆向ICO大势所趋，“好钱”寻找好项目',
                    'url': 'https://news.huoxing24.com/2018032721453164663.html'
                },
                {
                    'title': '第18期：Beecool创始人朱潘谈区块链社群：一味拉人与圈牛羊无异，围绕市场生态做产品',
                    'url': 'https://news.huoxing24.com/2018032823490348144.html'
                },
                {
                    'title': '第19期：丰元创投朱会灿：做好ICO破灭的心理准备，不要盲目乐观',
                    'url': 'https://news.huoxing24.com/2018032913315110738.html'
                },
                {
                    'title': '第20期：引力区创始人廖洋阳：EOS超级节点竞选6月才是开始，做公链是长跑',
                    'url': 'https://news.huoxing24.com/2018033023572110830.html'
                },
                {
                    'title': '第21期：YOYOW创始人刘强：Token是股权的升级版，是加速器',
                    'url': 'https://news.huoxing24.com/2018033101024123432.html'
                },
                {
                    'title': '第22期：Hydro Protocol李天放：稳定币的难度是经济体系设计和培养信仰',
                    'url': 'https://news.huoxing24.com/2018040101262225827.html'
                },
                {
                    'title': '第23期：CDC消费链杨宁澄清：割点韭菜就跑路？我的目标是颠覆谷歌阿里',
                    'url': 'https://news.huoxing24.com/2018040217531470507.html'
                },
                {
                    'title': '第24期：CoinTiger创始人凌凤琪：熊市难掩向上趋势，会洗牌带来机会',
                    'url': 'https://news.huoxing24.com/2018040222011303607.html'
                },
                {
                    'title': '第25期：加密经济学专家龚健：隐私是区块链商业化落地的根本',
                    'url': 'https://news.huoxing24.com/2018040301325366052.html'
                },
                {
                    'title': '第26期：铂欣资本陈昕：区块链是技术和经济结合的微创新，是巨大的行业泡沫',
                    'url': 'https://news.huoxing24.com/2018040421093433008.html'
                },
                {
                    'title': '第27期：普华资本合伙人蒋纯：媒体是行业指数基金，区块链发展要稳步推进',
                    'url': 'https://news.huoxing24.com/2018040520372447765.html'
                },
                {
                    'title': '第28期：EKT CEO周迅：时间戳是共识机制里特别关键的问题',
                    'url': 'https://news.huoxing24.com/2018040600054792287.html'
                },
                {
                    'title': '第29期：工经所所长于佳宁：发展数字经济离不开发展区块链产业',
                    'url': 'https://news.huoxing24.com/2018040714054018897.html'
                },
                {
                    'title': '第30期：BKFUND管理合伙人许超逸：2018是区块链市场冷静年，新周期需基础设施完善',
                    'url': 'https://news.huoxing24.com/2018040810504605738.html'
                },
                {
                    'title': '第31期：人大教授杨东：金融场景的痛点需要区块链技术来解决',
                    'url': 'https://news.huoxing24.com/2018041122010405834.html'
                },
                {
                    'title': '第32期：世界区块链组织首席经济学家金岩石：虚拟货币不落地，区块链金融或成骗子的天堂',
                    'url': 'https://news.huoxing24.com/2018041022173833673.html'
                },
                {
                    'title': '第33期：区块链3.0工程师邹杰：区块链结构设计与共识机制的选择',
                    'url': 'https://news.huoxing24.com/2018050714432793783.html'
                },
                {
                    'title': '第34期：离子链创始人刘涛：消费级物联网未来要有边缘计算能力',
                    'url': 'https://news.huoxing24.com/2018041023283569176.html'
                },
                {
                    'title': '第35期：金丘区块链创始人左鹏：服务实体经济才是未来区块链发展方向',
                    'url': 'https://news.huoxing24.com/2018041222033265263.html'
                },
                {
                    'title': '第36期：aelf创始人马昊伯：区块链成单一领域专业化竞争的利器',
                    'url': 'https://news.huoxing24.com/2018041117595627048.html'
                },
                {
                    'title': '第37期：千方基金创始人点付大头：取代POW实现51%抗拜占庭容错',
                    'url': 'https://news.huoxing24.com/2018041221194914521.html'
                },
                {
                    'title': '第38期：公信宝创始人黄敏强：下一代公链定能成为未来信用社会的基石',
                    'url': 'https://news.huoxing24.com/2018041817251501641.html'
                },
                {
                    'title': '第39期：了得资本创始人易理华：熊市投资要靠决策力和选头部项目',
                    'url': 'https://news.huoxing24.com/2018042016551593479.html'
                },
                {
                    'title': '第40期：丹华资本董事总经理Dovey Wan：区块链对游戏是线性的改造',
                    'url': 'https://news.huoxing24.com/2018042016312545658.html'
                },
                {
                    'title': '第41期：了得资本合伙人孔华威：区块链投资会看交易技术、物联网和游戏',
                    'url': 'https://news.huoxing24.com/2018041823200822923.html'
                },
                {
                    'title': '第42期：Ruff CEO Roy Li：我相信社区的力量和草根的崛起',
                    'url': 'https://news.huoxing24.com/2018042015480390172.html'
                },
                {
                    'title': '第43期：美国南加Edge区块链共享空间创始人任骏菲：揭秘洛杉矶及美国区块链项目',
                    'url': 'https://news.huoxing24.com/2018042017373870107.html'
                },
                {
                    'title': '第44期：亦来云联合创始人韩锋：确权数字依靠Token经济变为金融工具',
                    'url': 'https://news.huoxing24.com/2018050322594487632.html'
                },
                {
                    'title': '第45期：Ventureum.io项目CEO顾宇翔：项目长跑需要持续的自我监督和治理',
                    'url': 'https://news.huoxing24.com/2018042122134056023.html'
                },
                {
                    'title': '第46期：IOST/IOSToken联合创始人肖睿：看待区块链项目时，国内调侃国外批判',
                    'url': 'https://news.huoxing24.com/2018042118480034418.html'
                },
                {
                    'title': '第47期：能源区块链实验室创始合伙人曹寅：爱沙尼亚的数字国家实践和数字化国家的未来',
                    'url': 'https://news.huoxing24.com/2018042120080326034.html'
                },
                {
                    'title': '第48期：硅谷精神布道师Piero Scaruffi：区块链技术突破可能来自小的初创公司，EOS或成为区块链版“苹果商店”：火星财经社群',
                    'url': 'https://news.huoxing24.com/2018042220563152027.html'
                },
                {
                    'title': '第49期：armors联合创始人Rico、丁春妹、阿笨：安全是一个持续不断的事情，而非一劳永逸',
                    'url': 'https://news.huoxing24.com/2018042315165831954.html'
                },
                {
                    'title': '第50期：Feedsky创始人吕欣欣：日本对于虚拟货币以及区块链的态度比较激进',
                    'url': 'https://news.huoxing24.com/2018042419263891546.html'
                },
                {
                    'title': '第51期：INBlockchain合伙人Eric Meltzer：设计项目只是为了融资会很危险，项目≠功能',
                    'url': 'https://news.huoxing24.com/2018042519335119105.html'
                },
                {
                    'title': '第52期：DATA联合创始人叶阳：数字生态是区块链最能发挥作用的场景之一',
                    'url': 'https://news.huoxing24.com/2018042617390825468.html'
                },
                {
                    'title': '第53期：系数基金合伙人Chris Li：投资的项目一定要有创新',
                    'url': 'https://news.huoxing24.com/2018042721234702024.html'
                },
                {
                    'title': '第54期：IOST联合创始人兼CEO 钟家鸣Jimmy：IOST与下一代公链的发展',
                    'url': 'https://news.huoxing24.com/2018042816283115723.html'
                },
                {
                    'title': '第55期：硅谷会计事务所Zhong & Sanchez合创人Echo：不正确申报虚拟货币交易收入，在美国可能会受刑事起诉',
                    'url': 'https://news.huoxing24.com/2018042914561617608.html'
                },
                {
                    'title': '第56期：Hydro Protocol (HOT) 联合创始人博闻：：点对点交易所没有充值提现手续费和等待时间',
                    'url': 'https://news.huoxing24.com/2018043021125573601.html'
                },
                {
                    'title': '第57期：CEC首席战略顾问谢智勇：区块链在泛娱乐领域的应用',
                    'url': 'https://news.huoxing24.com/2018051000453266480.html'
                },
                {
                    'title': '第58期：MSC联合创始人张灿：传统体育版权商的首次区块链生态构建',
                    'url': 'https://news.huoxing24.com/2018051018171172055.html'
                },
                {
                    'title': '第59期：昆仑决创始人姜华：区块链技术可让预测竞猜的应用公开透明',
                    'url': 'https://news.huoxing24.com/2018051120215261341.html'
                },
                {
                    'title': '第60期：粉丝网CEO刘超：个人通证时代或成新的趋势',
                    'url': 'https://news.huoxing24.com/2018051218080180368.html'
                },
                {
                    'title': '第61期：DGames中国区负责人张旭：搭建游戏生态最重要的是为游戏资产确权',
                    'url': 'https://news.huoxing24.com/2018051321543232068.html'
                },
                {
                    'title': '第62期：永乐文化集团杨波：区块链可重塑娱乐经济体系',
                    'url': 'https://news.huoxing24.com/2018051420101426495.html'
                },
                {
                    'title': '第63期：秒啊CEO季小武：区块链符合宇宙对时间定义的规则',
                    'url': 'https://news.huoxing24.com/2018051521365868456.html'
                },
                {
                    'title': '第64期：远望资本创始合伙人田鸿飞：去中心化交易所也可实现中心化交易所的体验',
                    'url': 'https://news.huoxing24.com/2018051620070598573.html'
                },
                {
                    'title': '第65期：YEX发起人黄建：共识机制是未来社会制度的启蒙',
                    'url': 'https://news.huoxing24.com/2018051720370045573.html'
                },
                {
                    'title': '第66期：BB INDEX联合创始人王剑博士：加密币指数及其投资策略',
                    'url': 'https://news.huoxing24.com/2018051821160424746.html'
                },
                {
                    'title': '第67期：欧阳慧敏：2100万枚比特币被挖完并不意味着矿工会下岗',
                    'url': 'https://news.huoxing24.com/2018051919572502540.html'
                },
                {
                    'title': '第68期：Healio创始人Jochen Kumm博士：区块链保证基因隐私，Token分享学习内容',
                    'url': 'https://news.huoxing24.com/2018052022214187050.html'
                },
                {
                    'title': '第69期：吴宇遨：数字货币量化资管，机会与挑战',
                    'url': 'https://news.huoxing24.com/2018052120461319769.html'
                },
                {
                    'title': '第70期：《Vivi闯硅谷》创始人林薇：如何让国际韭菜认识你',
                    'url': 'https://news.huoxing24.com/2018052221352547725.html'
                },
                {
                    'title': '第71期：Usechain创始人曹辉宁：分布式记账带来信任，通证带来激励',
                    'url': 'https://news.huoxing24.com/2018052321242582892.html'
                },
                {
                    'title': '第72期：慢雾科技联合创始人余弦：审计智能合约，人做最后把关',
                    'url': 'https://news.huoxing24.com/2018052419125187613.html'
                },
                {
                    'title': '第73期：CarBlock创始人李佳：区块链可抢回数据所有权，全部归用户所有',
                    'url': 'https://news.huoxing24.com/2018052815183267230.html'
                },
                {
                    'title': '第74期：CarBlock创始人李佳：区块链技术解决车数据隐私问题，未来15年汽车市场规模会增至7500亿',
                    'url': 'https://news.huoxing24.com/2018061400225955547.html'
                },
                {
                    'title': '第75期：DFund 创始合伙人李泉、老葛：新交易所的机会在于新领域、新方式',
                    'url': 'https://news.huoxing24.com/2018052621323249872.html'
                },
                {
                    'title': '第76期：如是金融管清友：中国最大的风险来自中美关系的质变',
                    'url': 'https://news.huoxing24.com/2018062716313921646.html'
                },
                {
                    'title': '第77期：Armors联合创始人丁春妹：智能合约除发币外，还可实现很多事情',
                    'url': 'https://news.huoxing24.com/2018053017361178653.html'
                },
                {
                    'title': '第81期：触控科技创始人陈昊芝：谈谈你不懂的区块链游戏',
                    'url': 'https://news.huoxing24.com/2018062723192649440.html'
                },
                {
                    'title': '第82期：标准共识CEO陈怀远：每个投资者都有知情权',
                    'url': 'https://news.huoxing24.com/2018062723100958696.html'
                },
                {
                    'title': '第83期：WXY创始人于迪：品牌即共识',
                    'url': 'https://news.huoxing24.com/2018062723001219663.html'
                },
                {
                    'title': '第84期：德勤区块链实验室驻米兰首席技术官Stefano Lion Leone：如何从技术角度测评ICO',
                    'url': 'https://news.huoxing24.com/2018062722560588205.html'
                },
                {
                    'title': '第85期：Tokenonly尹棚: 开发一个用户量快速增长的钱包是一种怎样的体验',
                    'url': 'https://news.huoxing24.com/2018062722522288763.html'
                },
                {
                    'title': '第86期： BIG LOY创始人Michele Ruberl：区块链如何重塑旅游业？',
                    'url': 'https://news.huoxing24.com/2018062722402733832.html'
                },
                {
                    'title': '第87期：BlockVC创始人徐英凯：区块链项目投资策略与逻辑',
                    'url': 'https://news.huoxing24.com/2018062722343896360.html'
                },
                {
                    'title': '第88期：EOS原力创始人孤矢：EOS无限战争',
                    'url': 'https://news.huoxing24.com/2018062722185961980.html'
                },
                {
                    'title': '第89期：牛x社群创始人李东：打造社群良性价值观',
                    'url': 'https://news.huoxing24.com/2018062722083080619.html'
                },
                {
                    'title': '第90期：投缘帮创始人王翌：VC这个存在几十年的旧物种，早该被革命了',
                    'url': 'https://news.huoxing24.com/2018062123231030166.html'
                },
                {
                    'title': '第91期：CDC总干事杨宁：区块链项目拉盘那些事儿',
                    'url': 'https://news.huoxing24.com/2018062122475428986.html'
                },
                {
                    'title': '第92期：孔明屋CEO Alex YE：区块链应用落地的四轮驱动',
                    'url': 'https://news.huoxing24.com/2018062120593477308.html'
                },
                {
                    'title': '第93期：ValPromise创始人向涛： 区块链在农业风险管理的落地应用',
                    'url': 'https://news.huoxing24.com/2018062118162100473.html'
                },
                {
                    'title': '第94期：Steve Melnikoff：区块链的优势在于适用所有类型的项目',
                    'url': 'https://news.huoxing24.com/2018062117202791088.html'
                },
                {
                    'title': '第95期：币乎创始人鲁斌：基于区块链的代币投资者社区是怎样炼',
                    'url': 'https://news.huoxing24.com/2018062120350631026.html'
                },
                {
                    'title': '第96期：金丘区块链洪蜀宁：数字货币与法币如何共存？',
                    'url': 'https://news.huoxing24.com/2018062121415973751.html'
                },
                {
                    'title': '第97期：复旦大学赵运磊：一种全面提升BTC性能的签名算法',
                    'url': 'https://news.huoxing24.com/2018062121295604042.html'
                },
                {
                    'title': '第98期：八维资本阮宇博：美国最优秀的人才正在进入区块链',
                    'url': 'https://news.huoxing24.com/2018062120500909431.html'
                },
                {
                    'title': '第99期：楼霁月：现在是构建底层数字资产的好时机',
                    'url': 'https://news.huoxing24.com/2018062120500909431.html'
                },
                {
                    'title': '第100期：宫奇：可信赖的监管环境才能吸引无国界区块链人士',
                    'url': 'https://news.huoxing24.com/2018062122081017972.html'
                },
                {
                    'title': '第101期：韩国Fashion ET CEO 朴常赫：全球化、层级多、季节性强，当时尚行业遭遇新技术，用区块链改造视觉经济的可行方案',
                    'url': 'https://news.huoxing24.com/2018070323045076251.html'
                },
                {
                    'title': '第102期：国盛证券区块链研究院院长宋嘉吉：放弃「古典」拥抱「区块链」，是「离经叛道」还是「抢占先机」？',
                    'url': 'https://news.huoxing24.com/2018070323271377504.html'
                },
                {
                    'title': '第103期：爱思社区创始人虫哥：从买书送比特币到创造历史的爱思社区，虫哥的征途到底是什么？',
                    'url': 'https://news.huoxing24.com/2018070323392104473.html'
                },
                {
                    'title': '第104期：嘉楠耘智区块链事业部总经理邵建良：区块链投资的“正确姿态”',
                    'url': 'https://news.huoxing24.com/2018070323511913207.html'
                },
                {
                    'title': '第105期： Zeniex CEO 崔敬俊：韩国虚拟货币市场与政府监管',
                    'url': 'https://news.huoxing24.com/2018070400050406262.html'
                },
                {
                    'title': '第106期： 杨耀东 QuarkChain：共识和拜占庭经济体',
                    'url': 'https://news.huoxing24.com/2018070415160963589.html'
                },
                {
                    'title': '第107期：James Jung：亚洲区块链需要走的方向',
                    'url': 'https://news.huoxing24.com/2018070415260492435.html'
                },
                {
                    'title': '第108期：乔峰：EOS通过透明度和治理解决区块链中的毒性',
                    'url': 'https://news.huoxing24.com/2018070415432094355.html'
                },
                {
                    'title': '第109期： 霍曼资本缪可言：去中心化的定义与判别',
                    'url': 'https://news.huoxing24.com/2018070416100152822.html'
                },
                {
                    'title': '第110期：“甜甜说币”创始人曾颖：中国区块链如何出海日本',
                    'url': 'https://news.huoxing24.com/2018070416240211960.html'
                },
                {
                    'title': '第111期：若然Eileen：数字资产的管理及智能权益的应用',
                    'url': 'https://news.huoxing24.com/20180711000123794198.html'
                },
                {
                    'title': '第112期：XMax CEO 成也：如何实现高流动性及锁仓的辩证思考',
                    'url': 'https://news.huoxing24.com/20180711001054759355.html'
                },
                {
                    'title': '第113期：Alchemint创始人张婷：关于解决稳定币流动性不足的混合模式实践',
                    'url': 'https://news.huoxing24.com/20180711001753982107.html'
                },
                {
                    'title': '第114期：Chaince交易平台吴子臻 ：EOS RAM，被严重低估的新市场',
                    'url': 'https://news.huoxing24.com/20180709035436238602.html'
                },
                {
                    'title': '第115期：分布式投资90后成员Chloe：熊市里的投资逻辑',
                    'url': 'https://news.huoxing24.com/20180714152920127117.html'
                },
                {
                    'title': '第116期：Bitbill创始人谈国鹏：如何打造安全好用的数字货币钱包？',
                    'url': 'https://news.huoxing24.com/20180714153525631529.html'
                },
                {
                    'title': '第117期：Musictum发起节点张张：Musictum如何用区块链重塑音乐新生态',
                    'url': 'https://news.huoxing24.com/20180714155004726599.html'
                },
                {
                    'title': '第118期：ShareX创始人李刚强：股权Token化是大势所趋',
                    'url': 'https://news.huoxing24.com/20180714162305215476.html'
                },
                {
                    'title': '第119期：Qbao Network创始人陈琳：数字货币钱包的发展，现状和未来',
                    'url': 'https://news.huoxing24.com/20180714164030284489.html'
                },
                {
                    'title': '第120期：丹华资本丁若宇：跨链是区块链经济和实体经济的桥梁',
                    'url': 'https://news.huoxing24.com/20180714160754919112.html'
                },
                {
                    'title': '第121期：BGogo交易所王启恒：巨头不需要也不可能去中心化',
                    'url': 'https://news.huoxing24.com/20180715164453299796.html'
                },
                {
                    'title': '第122期：Bpa&Try 创始人刘明：区块链落地神学家指路，稳定币先行紧跟上身份',
                    'url': 'https://news.huoxing24.com/20180718195056784297.html'
                },
                {
                    'title': '第124期：币优陈勇：让小白用户零成本交易挖矿',
                    'url': 'https://news.huoxing24.com/20180719010449097245.html'
                },
                {
                    'title': '第125期：PTS张佳辰：区块链对数据协作存在天然优势',
                    'url': 'https://news.huoxing24.com/20180720004906923890.html'
                },
                {
                    'title': '第126期：刘劭康：正当地做市商，利益操纵者的第一道防线',
                    'url': 'https://news.huoxing24.com/20180721005236103373.html'
                },
                {
                    'title': '第127期：向亚贞：如何在海外做营销',
                    'url': 'https://news.huoxing24.com/20180722222812222708.html'
                },
                {
                    'title': '第128期：黄锦：做“币牛牛”的整体商业思考',
                    'url': 'https://news.huoxing24.com/20180723222512424738.html'
                },
                {
                    'title': '第129期：董沫：从加密货币经济学角度论币的长期价值',
                    'url': 'https://news.huoxing24.com/20180724235151855924.html'
                },
                {
                    'title': '第130期：Boxmining创始人Michael：利用社交媒体搭建中西方桥梁',
                    'url': 'https://news.huoxing24.com/20180725235812800059.html'
                },
                {
                    'title': '第131期：ABC区块链社区陈伦荣：区块链如何赋能社会管理？',
                    'url': 'https://news.huoxing24.com/20180727002328219663.html'
                },
                {
                    'title': '第132期：Oleg：如何基于社区做ICO项目分析',
                    'url': 'https://news.huoxing24.com/20180727230635955216.html'
                },
                {
                    'title': '第133期：Allan Zhang：用区块链驱动人工智能',
                    'url': 'https://news.huoxing24.com/20180728232213227391.html'
                },
                {
                    'title': '第134期：李宏伟: 印度区块链生态和ICO项目发展趋势',
                    'url': 'https://news.huoxing24.com/20180729231338667936.html'
                },
                {
                    'title': '第135期：超脑链郭睿：推动区块链赋能实体经济',
                    'url': 'https://news.huoxing24.com/20180730234910511558.html'
                },
                {
                    'title': '第136期：链安科技杨霞：如何预防智能合约漏洞',
                    'url': 'https://news.huoxing24.com/20180801000718143065.html'
                },
                {
                    'title': '第137期：积木云CEO明中行：拥抱下一代互联网',
                    'url': 'https://news.huoxing24.com/20180801225411762818.html'
                },
                {
                    'title': '第138期：Nervos吕国宁：下一代区块链基础设施',
                    'url': 'https://news.huoxing24.com/20180802223455655284.html'
                },
                {
                    'title': '第140期：CelesOS杨扬：新一代共识算法DPoW',
                    'url': 'https://news.huoxing24.com/20180804235009335356.html'
                },
                {
                    'title': '第141期：CertiK顾荣辉：构建安全可靠的区块链生态',
                    'url': 'https://news.huoxing24.com/20180805221802423537.html'
                },
                {
                    'title': '第142期： NKN Labs李彦博：用区块链改造传统网络传输',
                    'url': 'https://news.huoxing24.com/20180810173824690613.html'
                },
                {
                    'title': '第143期：本体创始人李俊：区块链能否成为主流行业基础设施',
                    'url': 'https://news.huoxing24.com/20180809143305556367.html'
                },
                {
                    'title': '第144期：Bitmark CEO：用数字资产区块链激活下一个爆款游戏',
                    'url': 'https://news.huoxing24.com/20180809172145489148.html'
                },
                {
                    'title': '第145期： IoTeX CEO：用区块链构造“超智物世界”',
                    'url': 'https://news.huoxing24.com/20180810193123548117.html'
                },
                {
                    'title': '第146期：孙诗皓：数字货币从交易驱动到资产管理时代',
                    'url': 'https://news.huoxing24.com/20180813122659315669.html'
                },
                {
                    'title': '第147期：费定安：链改能否助传统企业崛起？',
                    'url': 'https://news.huoxing24.com/20180813122805404528.html'
                },
                {
                    'title': '第148期 ：“史上最穷项目”ENU牛油果的野蛮生长',
                    'url': 'https://news.huoxing24.com/20180814232815186740.html'
                },
                {
                    'title': '第149期：彭云：BitUP的二级市场逻辑—指数与量化',
                    'url': 'https://news.huoxing24.com/20180815230201582212.html'
                },
                {
                    'title': '第151期：DPLAN杨昂然：通证经济改变未来商业生态',
                    'url': 'https://news.huoxing24.com/20180817235904679207.html'
                },
                {
                    'title': '第152期：周渊凯：区块链时代数字资产管理平台的价值和发展',
                    'url': 'https://news.huoxing24.com/20180818223927212676.html'
                },
                {
                    'title': '第153期：U&TOKEN程琛：认知与共识，无谓牛熊',
                    'url': 'https://news.huoxing24.com/20180819234506411549.html'
                },
                {
                    'title': '第154期：Jayden Wei：安圭拉经济特区—通证经济的试验田',
                    'url': 'https://news.huoxing24.com/20180821233952492926.html'
                },
                {
                    'title': '第155期：熊志敏：区块链之外的分布式账本新技术IOTA',
                    'url': 'https://news.huoxing24.com/20180822235029181622.html'
                },
                {
                    'title': '第156期：神马矿机张晓霆：矿机百家商战，谁能一骑绝尘？',
                    'url': 'https://news.huoxing24.com/20180823230033765911.html'
                },
                {
                    'title': '第157期 ：Frank Ling：区块链生态环境彻底垮塌，需要推倒重建',
                    'url': 'https://news.huoxing24.com/20180824232606276204.html'
                },
                {
                    'title': '第158期 ：鱼池矿工大白鲨：挖矿有风险，谨防这些坑',
                    'url': 'https://news.huoxing24.com/20180826223956476647.html'
                },
                {
                    'title': '第159期 ：DappReview牛凤轩：区块链游戏的发展和机遇',
                    'url': 'https://news.huoxing24.com/20180828220939651868.html'
                },
                {
                    'title': '第160期 ：岳汉超：如何布局全球区块链开发者生态',
                    'url': 'https://news.huoxing24.com/20180829214802861384.html'
                },
                {
                    'title': '第161期 ：ARPA徐茂桐：当隐私保护与区块链和密码学邂逅',
                    'url': 'https://news.huoxing24.com/20180830225453596184.html'
                },
                {
                    'title': '第162期 ：MakerDAO潘超：稳定不稳定的加密经济',
                    'url': 'https://news.huoxing24.com/20180831221209490718.html'
                },
                {
                    'title': '第163期 ：宋鹏程：区块链衍生品和风险交易市场的发展',
                    'url': 'https://news.huoxing24.com/20180901231952371054.html'
                },
                {
                    'title': '第164期 ：何天阳：如何帮区块链在熊市破冰？',
                    'url': 'https://news.huoxing24.com/20180902230640823621.html'
                },
                {
                    'title': '第165期 ：华为张小军：区块链安全和未来架构方向',
                    'url': 'https://news.huoxing24.com/20180904212232733819.html'
                },
                {
                    'title': '第166期：Ares Tech李志超：欧洲区块链游戏产业观察',
                    'url': 'https://news.huoxing24.com/20180906224319718005.html'
                },
                {
                    'title': '第167期 ：初链张翰：PoW浴火重生？从根本上抗ASIC做起',
                    'url': 'https://news.huoxing24.com/20180907214833076952.html'
                },
                {
                    'title': '第168期 ：中国政法大学孙志勇：全球视角的区块链监管',
                    'url': 'https://news.huoxing24.com/20180908220236130816.html'
                },
                {
                    'title': '第169期 ：安比实验室郭宇：区块链安全那些坑',
                    'url': 'https://news.huoxing24.com/20180909220826605441.html'
                },
                {
                    'title': '第170期 ：知道创宇周景平、潘少华：区块链安全攻防之道',
                    'url': 'https://news.huoxing24.com/20180910224548941445.html'
                },
                {
                    'title': '第171期 ：香港区块链协会梁捷扬：香港新经济下的新机会',
                    'url': 'https://news.huoxing24.com/20180912232950603476.html'
                },
                {
                    'title': '第173期 ：李俊山：区块链来了，先变的是你的认知',
                    'url': 'https://news.huoxing24.com/20180914231701634901.html'
                },
                {
                    'title': '第174期 ：密安网络韩永飞：区块链的来龙去脉',
                    'url': 'https://news.huoxing24.com/20180915230028713518.html'
                },
                {
                    'title': '第175期：BUMO郭强：通证经济实践的思考',
                    'url': 'https://news.huoxing24.com/20180916220940866341.html'
                },
                {
                    'title': '第176期 ：“陈九金服”陈九：区块链这趟车才刚刚启动',
                    'url': 'https://news.huoxing24.com/20180917232811221442.html'
                },
                {
                    'title': '第177期 ：肖飒：区块链项目的法律边界在哪里？',
                    'url': 'https://news.huoxing24.com/20180918202749483438.html'
                },
                {
                    'title': '第178期 ：链人CEO张晓媛：区块链人才市场的过去、现在和未来',
                    'url': 'https://news.huoxing24.com/20180919212826946825.html'
                },
                {
                    'title': '第179期 ：浙江现代数字金融科技研究院周子衡：数字经济与数字货币',
                    'url': 'https://news.huoxing24.com/20180920215904694315.html'
                },
                {
                    'title': '第180期 ：太一云董事长邓迪：如何用区块链构建人类命运共同体？',
                    'url': 'https://news.huoxing24.com/20180921093708254992.html'
                },
                {
                    'title': '第181期 ：everiToken发起人蔡恒进：传统企业如何进行链改',
                    'url': 'https://news.huoxing24.com/20180922224632652249.html'
                },
                {
                    'title': '第182期 ：格密链创始人陈智罡：重温比特币白皮书',
                    'url': 'https://news.huoxing24.com/20180923230434980039.html'
                },
                {
                    'title': '第183期 ：赵胜：寒冬中的区块链企业何去何从？',
                    'url': 'https://news.huoxing24.com/20180924230330078245.html'
                },
                {
                    'title': '第184期 ：AICHAIN创始人段凯：区块链也是一种“AI”',
                    'url': 'https://news.huoxing24.com/20180925231411709960.html'
                },
                {
                    'title': '第185期 ：红岸基金创始人任骏菲：如何在熊市中为信仰充值',
                    'url': 'https://news.huoxing24.com/20180926230116208241.html'
                },
                {
                    'title': '第186期 ：BTC.com庄重、胡静：PoW挖矿那些事',
                    'url': 'https://news.huoxing24.com/20180927231210859769.html'
                },
                {
                    'title': '第187期：乐东资本创始人杨林科：交易所是否还有投资机会',
                    'url': 'https://news.huoxing24.com/20180928225827704653.html'
                },
                {
                    'title': '第188期 ：Penta创始人David：区块链如何才能大规模应用',
                    'url': 'https://news.huoxing24.com/20180929231903323541.html'
                },
                {
                    'title': '第189期：丹华资本严静思：区块链创业者的幸运和DApp的最终形态',
                    'url': 'https://news.huoxing24.com/20180930235955507423.html'
                },
                {
                    'title': '第190期：PopulStay创始人王跃：旅游DApp或成区块链超级应用',
                    'url': 'https://news.huoxing24.com/20181001223621997372.html'
                },
                {
                    'title': '第191期 ：CoinXP联合创始人梁亮：如何走出熊市？',
                    'url': 'https://news.huoxing24.com/20181002232556682428.html'
                },
                {
                    'title': '第192期：MayLiu：华尔街正积极推进数字货币发展',
                    'url': 'https://news.huoxing24.com/20181004233232682690.html'
                },
                {
                    'title': '第193期 ：ENChain联创朱峰：通证经济系统的治理模型研究',
                    'url': 'https://news.huoxing24.com/20181010230157509307.html'
                },
                {
                    'title': '第194期 ：爱员工创始人赵杨晛：区块链带来的新社交形态',
                    'url': 'https://news.huoxing24.com/20181011193337636773.html'
                },
                {
                    'title': '第195期 ：Bizkey联创张晓航：区块链如何赋能实体零售',
                    'url': 'https://news.huoxing24.com/20181012174038461541.html'
                },
                {
                    'title': '第196期 ：BHPC联创芮雄：算力通证化的金融逻辑',
                    'url': 'https://news.huoxing24.com/20181013225948873010.html'
                },
                {
                    'title': '第197期： Henry He：通证设计中那些好的、坏的和丑恶的',
                    'url': 'https://news.huoxing24.com/20181014181234608099.html'
                },
                {
                    'title': '第198期：WeDive袁利：用通证经济破解创新陷阱',
                    'url': 'https://news.huoxing24.com/20181015173839580903.html'
                },
                {
                    'title': '第199期：BiMoney 创始人任锋：那些年被盗的12亿美金！',
                    'url': 'https://news.huoxing24.com/20181016223425565196.html'
                },
                {
                    'title': '第200期 ：快知实验室合伙人方军：区块链变革互联网平台的路径',
                    'url': 'https://news.huoxing24.com/20181017224929916939.html'
                },
                {
                    'title': '第201期 ：丘比特CBIT创始人李晶：区块链创造爱情表达新体验',
                    'url': 'https://news.huoxing24.com/20181019200338255677.html'
                },
                {
                    'title': '第202期 ：ASA Robotics CTO曹大军：机器人的价值与未来的一代',
                    'url': 'https://news.huoxing24.com/20181020230926754101.html'
                },
                {
                    'title': '第203期 ：大健康公链生命之花创始人陶太胜：区块链对大健康的深远影响',
                    'url': 'https://news.huoxing24.com/20181021232129893047.html'
                },
                {
                    'title': '第204期 ：上海戳记科技创始人郭成淦：普惠AI从Token激励的AI数据标注开始',
                    'url': 'https://news.huoxing24.com/20181022223454557649.html'
                },
                {
                    'title': '第205期 ：RSChain创始人李成轶：基于区块链的空间信息智能感知网络',
                    'url': 'https://news.huoxing24.com/20181022231013817245.html'
                },
                {
                    'title': '第206期 ：CENTRALITY联创Jerry Yuan：打造万马奔腾的区块链生态系统',
                    'url': 'https://news.huoxing24.com/20181023224139816722.html'
                },
                {
                    'title': '第207期 ：Opporty创始人：基于以太坊Plasma Cash的国际贸易平台',
                    'url': 'https://news.huoxing24.com/20181024230916074037.html'
                },
                {
                    'title': '第208期：Frontier Ventures合伙人Igor Basko： 金融科技趋势AI和区块链',
                    'url': 'https://news.huoxing24.com/20181025224427502468.html'
                },
                {
                    'title': '第209期 ：虫一投资联合创始人张晔：浅谈IABC赋能大型陆上海洋牧场的规划和实践',
                    'url': 'https://news.huoxing24.com/20181026222218666649.html'
                },
                {
                    'title': '第210期 ：深见网络科技负责人张颖峰：iABC—助力企业升级的思考和实践',
                    'url': 'https://news.huoxing24.com/20181027230015879092.html'
                },
                {
                    'title': '第211期 ：俄罗斯加密货币和区块链协会中国负责人Juliet：俄罗斯区块链和加密货币——技术资源和合作前景',
                    'url': 'https://news.huoxing24.com/20181028220944618492.html'
                },
                {
                    'title': '第212期：秘猿科技首席产品官王博：Nervos Layer2 架构分享',
                    'url': 'https://news.huoxing24.com/20181029213303401942.html'
                },
                {
                    'title': '第213期 ：纯白矩阵CEO吴啸：浅谈区块链游戏设计',
                    'url': 'https://news.huoxing24.com/20181030222621278008.html'
                },
                {
                    'title': '第214期 ：MixMarvel CEO张璇：区块链游戏的挑战',
                    'url': 'https://news.huoxing24.com/20181031235345835459.html'
                },
                {
                    'title': '第215期 ：Cocos-BCX首席技术顾问：通用数字资产标准的设计与游戏逻辑的链上表达',
                    'url': 'https://news.huoxing24.com/20181101180220499432.html'
                },
                {
                    'title': '第216期 ：可盈科技创始人沈东雄：区块链行业新风向——量化交易',
                    'url': 'https://news.huoxing24.com/20181101221348712538.html'
                },
                {
                    'title': '第217期：UOC创始人贾可：网游产业，将在5年内终结',
                    'url': 'https://news.huoxing24.com/20181102221304643520.html'
                },
                {
                    'title': '第218期 ：TonArts创始人宋阳：当NFT资产遇上区块链游戏',
                    'url': 'https://news.huoxing24.com/20181103214810292624.html'
                },
                {
                    'title': '第219期 ：Oath Protocol徐寅：用治理和仲裁破解区块链核心安全问题',
                    'url': 'https://news.huoxing24.com/20181106222046342154.html'
                },
                {
                    'title': '第220期 ：Securitize产品战略副总裁Jorge：解析ST发行平台与数字证券协议',
                    'url': 'https://news.huoxing24.com/20181106202935526132.html'
                },
                {
                    'title': '第221期 ：标准共识 STO 首席研究官李自鹏：STO 的前景及困境',
                    'url': 'https://news.huoxing24.com/20181107220910761754.html'
                },
                {
                    'title': '第222期：流动资本合伙人劳坤：STO本质和二级市场展望和挑战',
                    'url': 'https://news.huoxing24.com/20181108213810591111.html'
                },
                {
                    'title': '第223期：RockTreeLEX创始人欧阳默：STO 合规最强攻略',
                    'url': 'https://news.huoxing24.com/20181109230529151580.html'
                },
                {
                    'title': '第224期 ：创世资本首席分析师许艺严：如何将适合的资产设计成最完美的STO？',
                    'url': 'https://news.huoxing24.com/20181110213603299455.html'
                },
                {
                    'title': '第225期：RAC联合创始人冯木白：如何在STO的新时代产生巨大的回报？',
                    'url': 'https://news.huoxing24.com/20181112163646449128.html'
                },
                {
                    'title': '第226期 ：数字蚂蚁区块链陈雪刚：中本聪如何做区块链项目？',
                    'url': 'https://news.huoxing24.com/20181121224126248306.html'
                },
                {
                    'title': '第227期：隐私进化论——从DASH到DERO',
                    'url': 'https://news.huoxing24.com/20181123225701944885.html'
                },
                {
                    'title': '第228期 ：莱比特矿池创始人江卓尔：比特币分叉那些事',
                    'url': 'https://news.huoxing24.com/20181126000106585952.html'
                },
                {
                    'title': '第229期：NULS张星：跨链技术的演进',
                    'url': 'https://news.huoxing24.com/20181125234507521874.html'
                },
                {
                    'title': '第230期 ：CSDN副总裁孟岩:通证经济的发展和若干前沿课题',
                    'url': 'https://news.huoxing24.com/20181126215137872664.html'
                },
                {
                    'title': '第231期 ：虫洞项目负责人姜家志：ETH、EOS与BCH智能合约框架比较',
                    'url': 'https://news.huoxing24.com/20181127230310763512.html'
                },
                {
                    'title': '第232期 ：劫波科技创始人李凯龙：区块链的5大技术内核与博弈',
                    'url': 'https://news.huoxing24.com/20181201222051322191.html'
                },
                {
                    'title': '第233期 ：锐格信安CEO雷年胜：数字资产，安全是“硬”道理',
                    'url': 'https://news.huoxing24.com/20181206215615617729.html'
                },
                {
                    'title': '第234期 ：BTC Media古千峰：用Web3.0开启未来10年的财富大门',
                    'url': 'https://news.huoxing24.com/20181212223741607577.html'
                },
                {
                    'title': '第235期 ：Cobo联合创始人神鱼：如何穿越牛熊',
                    'url': 'https://news.huoxing24.com/20181213202935633389.html'
                },
                {
                    'title': '第236期 ：HKDT总裁徐飞：稳定币是区块链2.0时代的标志性产品',
                    'url': 'https://news.huoxing24.com/20181221185632287207.html'
                },
                {
                    'title': '第237期 ：Conflux伍鸣：用DAG结构提升中本聪共识的吞吐率',
                    'url': 'https://news.huoxing24.com/20181225224648216504.html'
                },
                {
                    'title': '第238期 ：高维地球任轶：驱动分布式商业的空间预言机',
                    'url': 'https://news.huoxing24.com/20181227214634432467.html'
                },
                {
                    'title': '第239期 ：BHEX文凯：数字资产交易所布局公链的价值与未来',
                    'url': 'https://news.huoxing24.com/20190111193004945713.html'
                },
                {
                    'title': '第240期 ：港盛科技CTO史亮：用金融IT服务助力数字资产行业',
                    'url': 'https://news.huoxing24.com/20190115232455439350.html'
                },
                {
                    'title': '第241期 ：BikiCoin CEO：交易所如何在熊市突围？',
                    'url': 'https://news.huoxing24.com/20190119115705998359.html'
                },
                {
                    'title': '第242期：量化投资学会丁鹏：数字资产量化投资，不只是追涨杀跌',
                    'url': 'https://news.huoxing24.com/20190302091800227229.html'
                },
                {
                    'title': '第243期：慢雾科技Keywolf：保护数字资产安全，先做好这三步',
                    'url': 'https://news.huoxing24.com/20190323082549241273.html'
                },
                {
                    'title': '第244期：RedFOX Labs CEO：区块链东南亚市场新机遇',
                    'url': 'https://news.huoxing24.com/20190417223717161675.html'
                },
                {
                    'title': '第245期：STAKING创始人：读懂Staking Economy 背后的风险与收益',
                    'url': 'https://news.huoxing24.com/20190420221135531437.html'
                },
                {
                    'title': '第246期：ARPA CEO徐茂桐： 隐私数据安全共享正在创造企业级风口',
                    'url': 'https://news.huoxing24.com/20190425221824686909.html'
                },
                {
                    'title': '第247期：Eirenex创始人：少了交易所，区块链带来的“产权革命”只成功一半',
                    'url': 'https://news.huoxing24.com/20190426203040286679.html'
                },
                {
                    'title': '第248期：TokenGazer范宏达：技术共识+机构共识+应用扩展是近期行情的孕育力量',
                    'url': 'https://news.huoxing24.com/20190522221329780112.html'
                },
                {
                    'title': '第249期：Lambda何晓阳：用区块链实现数据自由存储和交易是大势所趋',
                    'url': 'https://news.huoxing24.com/20190603192155557920.html'
                },
                {
                    'title': '第250期：公信宝黄敏强&LongBit Sharon：交易所与公链生态的突围之路',
                    'url': 'https://news.huoxing24.com/20190611195336751794.html'
                },
                {
                    'title': '第251期：COTI CEO Shahaf：区块链支付系统如何挑战传统支付企业',
                    'url': 'https://news.huoxing24.com/20190611214643256218.html'
                },
                {
                    'title': '第252期：水木清华TBC袁晔：Libra是“海洋文明”的具体表达',
                    'url': 'https://news.huoxing24.com/20190711192550497679.html'
                },
                {
                    'title': '第253期：BHEX Labs首期项目YAN CHAIN创新经济模型大揭秘',
                    'url': 'https://news.huoxing24.com/20190715205336595533.html'
                },
                {
                    'title': '第254期：火币研究院首席研究员李慧：未来爆款何在？区块链游戏行业的变革与突破',
                    'url': 'https://news.huoxing24.com/20190823152225521805.html'
                }
            ]
        },
        'marsUniversityCourse': {
            'title': '火星财经大学课程',
            'pcImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601267776561.jpg',
            'mImgUrl': '',
            'introduce': '顶级导师面对面，学习区块链第一站',
            'newsList': [
                {
                    'title': '',
                    'url': ''
                },
                {
                    'title': '',
                    'url': ''
                }
            ]
        },
        'tenQuestions': {
            'title': '王峰十问',
            'pcImgUrl': 'https://hx24.huoxing24.com/image/news/2019/11/01/1572601268222839.jpg',
            'mImgUrl': '',
            'introduce': '尖峰对话，洞悉区块链世界的人性与人格',
            'newsList': [
                {
                    'title': '第1期：中国天使投资第一人薛蛮子：与其说我是比特币信仰者，不如说是人性的信仰者',
                    'url': 'https://news.huoxing24.com/2018022423201493836.html'
                },
                {
                    'title': '第2期：Qtum量子链发起人帅初：区块链短期难以撼动BAT，建议朱啸虎对新事物应动态看待',
                    'url': 'https://news.huoxing24.com/2018022523383179478.html'
                },
                {
                    'title': '第3期：快的打车创始人陈伟星：我想活在新世界、赵长鹏很像王兴、失去快的天天买醉、用区块链解决世界难题',
                    'url': 'https://news.huoxing24.com/2018022701085099964.html'
                },
                {
                    'title': '第4期：湖畔大学教育长曾鸣：区块链第一浪发展会很快，但第二浪会比大家想象得慢很多',
                    'url': 'https://news.huoxing24.com/2018030118430352402.html'
                },
                {
                    'title': '第5期：中国比特币首富李笑来：首次回应拥有6位数比特币传闻——曾经有过',
                    'url': 'https://news.huoxing24.com/2018030517354899646.html'
                },
                {
                    'title': '第6期：金沙江创投朱啸虎：作为早期投资人，我们对任何技术都有好奇心',
                    'url': 'https://news.huoxing24.com/2018030716083225690.html'
                },
                {
                    'title': '第7期：互联网老男孩杨宁：区块链给了90后掀桌子的机会',
                    'url': 'https://news.huoxing24.com/2018031219443257249.html'
                },
                {
                    'title': '第8期：郭宏才（宝二爷）：崇拜山西老乡贾跃亭，曾打算海外发ICO收购乐视',
                    'url': 'https://news.huoxing24.com/2018031620461999476.html'
                },
                {
                    'title': '第9期：亦来云创始人陈榕：我为什么要坚持做区块链操作系统',
                    'url': 'https://news.huoxing24.com/2018032008240863734.html'
                },
                {
                    'title': '第10期：CSDN蒋涛：区块链是程序员的时代，程序员的边界在于人性的边界',
                    'url': 'https://news.huoxing24.com/2018032620211065613.html'
                },
                {
                    'title': '第11期：Dfund创始人赵东：每一次吃屎都赶不上热的创业者千万别投',
                    'url': 'https://news.huoxing24.com/2018032917044604772.html'
                },
                {
                    'title': '第12期：天使投资人郑刚：特斯拉穿越生死无数次，坚定看好电动汽车的未来',
                    'url': 'https://news.huoxing24.com/2018040921070199182.html'
                },
                {
                    'title': '第13期：波场TRON创始人孙宇晨：宁可背负骂名把事情做成，也不做悲剧英雄',
                    'url': 'https://news.huoxing24.com/2018042519304176847.html'
                },
                {
                    'title': '第14期：美图公司董事长蔡文胜：未来三年每个互联网公司都会结合区块链技术',
                    'url': 'https://news.huoxing24.com/2018050214251434055.html'
                },
                {
                    'title': '第15期：币圈大佬老猫：相信中本聪，还是相信巴菲特？',
                    'url': 'https://news.huoxing24.com/2018051017533566446.html'
                },
                {
                    'title': '第16期：锤子科技创始人罗永浩：再谈创业十大关系，首次披露“区块链手机一定会做”',
                    'url': 'https://news.huoxing24.com/2018052116403630201.html'
                },
                {
                    'title': '第17期：奇虎360董事长周鸿祎：区块链数字货币史诗级漏洞，不是最后一个，也不是最厉害的',
                    'url': 'https://news.huoxing24.com/2018053012060827682.html'
                },
                {
                    'title': '第18期：荣耀掌门赵明：我不赞同将手机类比PC行业',
                    'url': 'https://news.huoxing24.com/2018060817344720393.html'
                },
                {
                    'title': '第19期：比特大陆联合创始人吴忌寒：我不是一个精明的商人',
                    'url': 'https://news.huoxing24.com/2018061517234807956.html'
                },
                {
                    'title': '第20期：以太坊创始人V神：ETH价值并不依赖比特币',
                    'url': 'https://news.huoxing24.com/2018062216114032338.html'
                },
                {
                    'title': '第21期：破局者张健回应王峰十问：“FT是BTC2.0，任何新物种早期都被各种不理解！”',
                    'url': 'https://news.huoxing24.com/20191101124851904933.html'
                },
                {
                    'title': '第22期：币安CEO赵长鹏：谈周游列国、上币规则，再评“交易即挖矿”',
                    'url': 'https://news.huoxing24.com/2018070613145350079.html'
                },
                {
                    'title': '第23期：火币朱嘉伟：全面回应上币政策、高破发率、HADAX风波.....',
                    'url': 'https://news.huoxing24.com/2018070613140691921.html'
                },
                {
                    'title': '第24期：计算机安全教母宋晓冬：畅聊区块链与隐私保护、深度学习、安全防护的关系',
                    'url': 'https://news.huoxing24.com/20180905144925929358.html'
                },
                {
                    'title': '第25期：PoS共识机制发明人Sunny King：稳定币的影响被外界过度夸大',
                    'url': 'https://news.huoxing24.com/20180920151036119799.html'
                },
                {
                    'title': '第26期：陈一舟激辩王峰十问：我不是不想打硬仗，而是不想打一定会死的硬仗！',
                    'url': 'https://news.huoxing24.com/20181117004045250331.html'
                },
                {
                    'title': '第27期：徐小平答王峰十问：中国创业“黄金十年”确已结束，“白金十年”正扑面而来！',
                    'url': 'https://news.huoxing24.com/20181201000801636418.html'
                },
                {
                    'title': '第28期：周航做客王峰十问坦言：极其狼性的对抗性战争不适合我，我到今天也不喜欢',
                    'url': 'https://news.huoxing24.com/20181214223002189449.html'
                },
                {
                    'title': '第29期：王峰现场十问火币李林：交易所最核心的能力就是选择好的资产，没有之一',
                    'url': 'https://news.huoxing24.com/20190328185829327914.html'
                },
                {
                    'title': '第30期：李国庆做客王峰十问: 只要聊10分钟就能让90后00后在我怀中哭泣',
                    'url': 'https://news.huoxing24.com/20190422223545114234.html'
                },
                {
                    'title': '第31期：“王峰十问”走进2019数博会，与凯文·凯利等人激辩区块链',
                    'url': 'https://news.huoxing24.com/20190528075315702674.html'
                },
                {
                    'title': '第32期：“王峰十问”线下对话4大技术领袖，探讨数字经济范式重构',
                    'url': 'https://news.huoxing24.com/20190820173858791255.html'
                },
                {
                    'title': '第33期：MakerDAO创始人Rune首秀王峰十问，称DeFi借贷用户数中国居全球首位',
                    'url': 'https://news.huoxing24.com/20190905003929697004.html'
                },
                {
                    'title': '第34期：王峰两小时闭门对话Polkadot创始人Gavin Wood实录，带你了解Web 3.0、跨链机制、程序设计及“一键发链”那些事',
                    'url': 'https://news.huoxing24.com/20190929223843293345.html'
                },
                {
                    'title': '第35期：经济学家朱嘉明做客王峰十问：中央提倡区块链，将科学技术元素纳入治国理念， 其历史意义不可低估',
                    'url': 'https://news.huoxing24.com/20191105081339694577.html'
                }
            ]
        },
        'subjectObj': {
            newsList: [
                {
                    title: '专题报道：谷歌“量子霸权”对比特币和区块链造成威胁？',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021864728686.png',
                    url: 'https://news.huoxing24.com/feature/20191025164123913525'
                },
                {
                    title: '专题报道：聚焦Staking Economy背后的机会',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021865266295.png',
                    url: 'https://news.huoxing24.com/feature/20190606203614830908'
                },
                {
                    title: '专题报道：以太坊硬分叉成功，PoS转型之路开启',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021865568737.png',
                    url: 'https://news.huoxing24.com/feature/20181211155338380909'
                },
                {
                    title: '「火星财经总编时刻」第四期：dApp这一年',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021865991352.png',
                    url: 'https://news.huoxing24.com/feature/20190111204746121279'
                },
                {
                    title: '稳定币「风云」',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021866392821.png',
                    url: 'https://news.huoxing24.com/feature/20180913202935119778'
                },
                {
                    title: '专题报道 | 嘉宾有约共识论——Defi的未来应用与基础设施的搭建',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021866733122.png',
                    url: 'https://news.huoxing24.com/feature/20191105140053163815'
                },
                {
                    title: '专题报道：EOS一周年发布会',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021867046008.png',
                    url: 'https://news.huoxing24.com/feature/20190602001224963660'
                },
                {
                    title: '专题报道 | 比特币白皮书发布11周年',
                    img: 'https://hx24.huoxing24.com/image/news/2019/11/06/1573021867384312.png',
                    url: 'https://news.huoxing24.com/feature/20191031153807964647'
                }
            ]
        },
        'tagsArr': [
            '侧链', '跨链', '哈希值', 'POC', 'DPoS', '网络层', '共识层', 'DCO', '算力', '双重支付', 'STO', 'UTXO', 'TPS', '加密', '隔离见证', '图灵完备', '智能合约', 'Casper', 'Rust', '通证经济', 'MACD', '估值', 'DCEP', 'CBDC', 'Libra', 'DeFi', 'Dex', 'Dapp', '分叉', '闪电网络', '公链', '去中心化', '稳定币', 'V神', 'IEO']
    }
})
